<template>
    <div class="or-admin-product-constructor-table" :style="options.style">
        <or-product-table-ceil :options="options" :parent="{}" @edit-inner="edit_inner"/>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
    },
}
</script>

<style scoped>
    .or-admin-product-constructor-table {
        position: relative;
        border-radius: 8px;
        border: #EBB932 1px solid;
        overflow: hidden;
    }
</style>